<span class="example-pizza-party">
    Pizza party!!! 🍕
  </span>